export const selectAvatarUrl = state => state.avatar.avatarUrl
